import { ErrorCodes } from "./constants";

export const getErrorKey = (errorCode) => {
  return Object.keys(ErrorCodes).find((key) => ErrorCodes[key] === errorCode);
};
